import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { getCookie } from "../utils/cookies";

const onSuccess = (response: AxiosResponse) => {
  console.debug("Request Successful!", response);
  return response.data;
};

const onError = (error: AxiosError<any>) => {
  console.error("Request Failed:", error.config);

  if (error.response) {
    // Request was made but server responded with something
    // other than 2xx
    console.error("Status:", error.response.status);
    console.error("Data:", error.response.data);
    console.error("Headers:", error.response.headers);
  }

  return Promise.reject(error.response || error);
};

const client = (config: AxiosRequestConfig) => {
  const instance = axios.create({
    baseURL: config.baseURL ? config.baseURL : process.env.REACT_APP_API_URL,
  });

  return instance(config);
};

const request = async (options: AxiosRequestConfig) => {
  const accessToken = getCookie(document.cookie, "accessToken");

  const config: AxiosRequestConfig = {
    ...options,
    headers: {
      "Access-Control-Allow-Credentials": true,
      Authorization: `Bearer ${accessToken}`,
    },
    timeout: 10000,
  };

  return client(config).then(onSuccess).catch(onError);
};

export default request;
